/*eslint-disable*/
import React from "react";
/*eslint-enable*/

import T     from "./t.jsx";

export const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
export const NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*([\.\,]\d*)))\s*$/;
export const DATE_REGEXP   = /^\s*(\d{4})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])\s*$/;
export const PHONE_REGEXP = /^[0-9 ()+-]+$/

const TRANSLATE_PREFIX = "errors.";

/**
 * Excludes anything not a floating point number from the input string.
 */
export function allowNumeric(text) {
  return text.replace(",", ".").replace(/\.+/, ".").replace(/[^-+0-9,.]/, "");
}

/**
 * @param data Map(
 *   "errors": Array<string>,
 *   "dirty":  boolean
 * )
 */
export function displayErrors(data) {
  if(data.get("dirty")) {
    return data.get("errors", [])
      .map(e =>
           <T key={e} className="validation__message" component="p">{TRANSLATE_PREFIX + e}</T>
          );
  }

  return null;
}
